import React, {useState, useEffect} from "react"
import Clock from "./Clock"
import TimeLine from "./TimeLine"
import clockData from "./clockData"

function PartTwo(props) {
    const [slide, setSlide] = useState(0)
    const [text, setText] = useState("")
    const [time, setTime] = useState("")
    const [minuteHand, setMinuteHand] = useState(0)
    const [hourHand, setHourHand] = useState(0)
    const [buttonText, setButtonText] = useState("First Event")
        
    useEffect(() => {
        setText(clockData[slide].slideText)
        setTime(clockData[slide].timeText)
        setMinuteHand("rotate(" + clockData[slide].minuteRotation + "deg)")
        setHourHand("rotate(" + clockData[slide].hourRotation + "deg)")
        slide === 6 || slide === 0 ? setButtonText("First Event") : setButtonText("Next Event") 
    }, [slide])
    
    useEffect(() => {
        document.getElementById("minuteHandRotate").style.transform = minuteHand
        document.getElementById("hourHandRotate").style.transform = hourHand
    }, [minuteHand, hourHand])
    
    function advanceTime() {
        slide < 6 ? setSlide(prevSlide => prevSlide + 1) : setSlide(1)
    }
    
    return (
        <div>
            <h3 className="phaseIntro">We need to establish when the diamond was taken and who was in the building at that time. Luckily Dorris Humphries keeps a clear record for the museum's cloakroom. The bad news? Someone has tried to destroy the evidence.</h3>
        
            <div className="imageTextWrapper timelineWrapper">
                <Clock />
                <TimeLine handleClick={advanceTime} text={text} time={time} buttonText={buttonText} />
            </div>
        
            <h3>I have established a timeline of a few key events, the rest is down to you.</h3>
        </div>
    )
}

export default PartTwo